import * as React from 'react';
import makeIcon from './make_icon';
import { jsx as ___EmotionJSX } from "@emotion/core";
var roundFilled = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.1348 9.57231C17.3301 9.37705 17.3301 9.06047 17.1348 8.86521C16.9396 8.66994 16.623 8.66994 16.4277 8.86521L10 15.2929L6.85355 12.1464C6.65829 11.9512 6.34171 11.9512 6.14645 12.1464C5.95118 12.3417 5.95118 12.6583 6.14645 12.8535L9.64647 16.3536C9.84173 16.5488 10.1583 16.5488 10.3536 16.3536L17.1348 9.57231Z"
});
var roundLined = ___EmotionJSX(React.Fragment, null, ___EmotionJSX("path", {
  d: "M17.1349 9.5723C17.3301 9.37704 17.3301 9.06046 17.1349 8.8652C16.9396 8.66994 16.623 8.66993 16.4277 8.8652L10 15.2929L6.85355 12.1464C6.65829 11.9512 6.34171 11.9512 6.14645 12.1464C5.95118 12.3417 5.95118 12.6583 6.14645 12.8535L9.64645 16.3535C9.84171 16.5488 10.1583 16.5488 10.3536 16.3535L17.1349 9.5723Z"
}), ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
}));
var sharpFilled = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.1348 9.57231L17.4884 9.21876L16.7813 8.51165L16.4277 8.86521L10 15.2929L6.85355 12.1464L6.5 11.7929L5.79289 12.5L6.14645 12.8535L9.64647 16.3536L10 16.7071L10.3536 16.3536L17.1348 9.57231Z"
});
var sharpLined = ___EmotionJSX(React.Fragment, null, ___EmotionJSX("path", {
  d: "M10 16.7072L17.4884 9.21883L16.7813 8.51172L10 15.293L6.50001 11.793L5.79291 12.5001L10 16.7072Z"
}), ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
}));
var IconCheckmarkCircle = makeIcon('IconCheckmarkCircle', 'Checkmark Circle', false, {
  roundFilled,
  roundLined,
  sharpFilled,
  sharpLined
});
export default IconCheckmarkCircle;